module.exports = __webpack_public_path__ + "img/psd-logo.a9c28cb9.jpg";